"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Form;

var _react = _interopRequireWildcard(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*---------------------------------------------*/
function Form(props) {
  var _props$error;

  var BASE_CLASS = 'lth-c-form';

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      submitError = _useState4[0],
      setSubmitError = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      valid = _useState8[0],
      setValid = _useState8[1];

  var submitPromise = (0, _react.useRef)(null);
  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS);
  var style = (0, _useStyleBuilder.default)(props);
  var errors = props.errors || {};
  var error = (_props$error = props.error) !== null && _props$error !== void 0 ? _props$error : submitError;
  var children = wrapWithForm(props.children);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: classes,
    style: style,
    onSubmit: onSubmit
  }, error && !props.silent ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 16,
      color: 'var(--color-error-200)'
    }
  }, error) : null, children);
  /*------------------------------------------*/

  function onInputChange(value, name) {
    var newValues = _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, name, value));

    props.onChange && props.onChange(newValues);
    setValues(newValues);
    setValid(validate(props.children));

    function validate(children) {
      for (var i = 0; i < children.length; i++) {
        var _component$props, _component$props2;

        var component = children[i];

        if (component !== null && component !== void 0 && (_component$props = component.props) !== null && _component$props !== void 0 && _component$props.required && !values[component.props.name]) {
          return false;
        }

        return component !== null && component !== void 0 && (_component$props2 = component.props) !== null && _component$props2 !== void 0 && _component$props2.children ? validate(component.props.children) : true;
      }

      ;
    }
  }
  /*------------------------------------------*/


  function onSubmit(e) {
    e.preventDefault();
    setSubmitError(null);
    submitPromise.current = props.onSubmit && props.onSubmit(values);

    if (submitPromise.current) {
      setLoading(true);
      submitPromise.current.catch(function (error) {
        return setSubmitError(error || 'Error');
      }).finally(function () {
        return setLoading(false);
      });
    }
  }
  /*------------------------------------------*/


  function wrapWithForm(children) {
    return _react.default.Children.map(children, function (component, index) {
      if (!component || !component.props) {
        return component;
      }

      var props = {
        children: wrapWithForm(component.props.children)
      };

      if (component.props.name) {
        var _values$name;

        var name = component.props.name;
        props.value = (_values$name = values[name]) !== null && _values$name !== void 0 ? _values$name : component.props.value;
        props.error = !!errors[name] || component.props.error;
        props.message = errors[name] || component.props.message;

        props.onChange = function (value, name) {
          onInputChange(value, name); // should we use component.props.name instead?

          component.props.onChange && component.props.onChange(value, name);
        };
      }

      if (component.props.loading === Form.loading) {
        props.loading = loading;
      }

      if (component.props.valid === Form.valid) {
        props.valid = valid;
      }

      return /*#__PURE__*/_react.default.cloneElement(component, props);
    });
  }
}
/*---------------------------------------------*/


Form.loading = 'FORM-LOADING-PLACEHOLDER';
Form.valid = 'FORM-VALID-PLACEHOLDER';
/*---------------------------------------------*/

Form.METADATA = {
  name: 'Form',
  props: [{
    name: "error",
    type: "string"
  }, {
    name: 'onChange',
    type: 'function'
  }, {
    name: 'onSubmit',
    type: 'function'
  }],

  get demo() {
    // for some reason when adding demo as a regular member React complaints about type error
    return {
      content: /*#__PURE__*/_react.default.createElement(_.Stack, null, /*#__PURE__*/_react.default.createElement(_.Input, {
        type: "text",
        label: "Your name",
        name: "name",
        key: "name"
      }), /*#__PURE__*/_react.default.createElement(_.Input, {
        type: "number",
        label: "Your age",
        name: "age",
        key: "age"
      }), /*#__PURE__*/_react.default.createElement(_.Button, {
        label: "Submit",
        key: "submit"
      }))
    };
  }

};